export default __webpack_public_path__ + "static/media/SWT0540.34I-20612_-22459_0.33fd514c.jpg";